module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/A4XnU5/tc-custom/9781423646754.jpg?1707453063739",
      "alt": "This image is the cover for the book Illustrated Book of Edible Plants"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Illustrated Book of Edible Plants\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Histories, medicinal uses, and recipe ideas for food plants from A to Z—illustrated with beautiful watercolor art.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Focusing on the most growable vegetables, herbs, and fruits for the greatest number of people, Jack Staub tells the stories of their origins and apprises the home gardener on ways to use them, from the table to remedies and potions."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Up-to-the-minute cultivation and culinary advice are delivered with accessibility and wit, as well as tidbits of folkore and myth that surround these plants, from the author of"), _c('i', [_vm._v(" 75 Exciting Vegetables for Your Garden, 75 Remarkable Fruits for Your Garden, ")]), _vm._v("and"), _c('i', [_vm._v(" 75 Exceptional Herbs for Your Garden.")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jack Staub\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0